<script setup lang="ts">
// ⚠️ Could not locate Swiper.vue
// ⚠️ Could not locate SwiperSlide.vue
import { Swiper, SwiperSlide } from 'swiper/vue'

import { Autoplay, EffectFade, Pagination, Navigation } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
withDefaults(defineProps<MpdSwiperProps>(), {
  slides: () => [],
  options: () => {
    return {
      slidesPerView: 2.5,
      spaceBetween: 50,
      autoplay: true,
      direction: 'horizontal',
      speed: 1000,
      loop: false,
      navigation: false,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
      },
      pagination: false,
      onSwiper: () => {
        // console.log('Swiper Ready')
      },
      onSwiperChange: () => {
        // console.log('Swiper Changed')
      },
    }
  },
  cardComponent: () => resolveComponent('SwiperImage'),
  env: '',
})

const emit = defineEmits<{
  (e: 'redirect', slug: string): void
}>()

const swiper = ref()

interface SwiperOptions {
  slidesPerView?: number | 'auto'
  spaceBetween?: number
  autoplay?: {
    delay: number
  } | boolean
  speed?: number
  loop?: boolean
  direction?: 'horizontal' | 'vertical'
  onSwiper?: Function
  onSlideChange?: Function
  effect?: string
  breakpoints?: Record<string, any>
  pagination?: boolean
  navigation?: boolean
}

interface MpdSwiperProps {
  slides: any[]
  options: SwiperOptions
  env?: string
  cardComponent: typeof resolveComponent
}

function redirect(slug: string) {
  emit('redirect', slug)
}

defineExpose({
  swiper,
})
</script>

<template>
  <div class="sec-mpd-swiper" :class="options.effect">
    <Swiper
      ref="swiper"
      :modules="[Autoplay, EffectFade, Pagination, Navigation]"
      :slides-per-view="options.slidesPerView"
      :space-between="options.spaceBetween"
      :direction="options.direction"
      :speed="options.speed"
      :autoplay="options.autoplay"
      :effect="options.effect"
      :loop="options.loop"
      :breakpoints="options.breakpoints"
      :pagination="options.pagination"
      :navigation="options.navigation"

      @swiper="options.onSwiper"
      @slide-change="options.onSlideChange"
    >
      <template v-if="slides" && cardComponent>
        
        <SwiperSlide v-for="record, index in slides" :key="record.id">
          <component :is="cardComponent" :index="index" :item="record" :env="env" @redirect="redirect" />
        </SwiperSlide>
      </template>
    </Swiper>
  </div>
</template>

<style lang="scss">
.sec-mpd-swiper {
  &.fade {
    .swiper-slide {
      opacity: 0 !important;;
      transition: opacity 1s ease-in-out;
      &.swiper-slide-active {
        opacity: 1 !important;
      }
    }
  }

  .swiper-wrapper {
    width:100%;
    height:100%;

    .swiper-slide {
      width:100%;
      height:100%;

      // Specific Swiper Slides
      .swiper-home-hero {
        img {
          height:100% !important;
        }
      }
    }

  }
}
</style>
